import PageTour from './PageTour';

export * from './types';
export default PageTour;
